/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function () {
    const headings = Array.from(document.querySelectorAll('.column__heading'));

    function findHeading(text) {
      return headings.find(function (heading) {
        return heading.textContent.trim().toLowerCase() === text.toLowerCase();
      });
    }

    const heading1 = findHeading('Gratis verzending');
    const heading2 = findHeading('Makkelijk retourneren');
    const heading3 = findHeading('5000+ klanten');

    if (!heading1 || !heading2 || !heading3) return;

    const item1 = heading1.closest('.grid-item');
    const item2 = heading2.closest('.grid-item');
    const item3 = heading3.closest('.grid-item');

    if (!item1 || !item2 || !item3) return;

    const track = item1.parentElement;

    if (
      item2.parentElement !== track ||
      item3.parentElement !== track ||
      track.classList.contains('messermann-usp-track')
    ) {
      return;
    }

    const viewport = track.parentElement;

    track.classList.add('messermann-usp-track');
    viewport.classList.add('messermann-usp-viewport');

    const originalItems = [item1, item2, item3];

    originalItems.forEach(function (item) {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    function setUspSize() {
      const viewportWidth = viewport.getBoundingClientRect().width;

      let itemWidth;

      if (window.innerWidth <= 749) {
        itemWidth = viewportWidth * 0.82;
      } else {
        itemWidth = viewportWidth / 3;
      }

      track.style.setProperty('--usp-item-width', itemWidth + 'px');
      track.style.setProperty('--usp-shift', -(itemWidth * 3) + 'px');
    }

    setUspSize();
    window.addEventListener('resize', setUspSize);
  });




  document.addEventListener('DOMContentLoaded', function () {
  const newsletterTitle = document.querySelector(
    '.footer__block--newsletter .footer__block__title'
  );

  if (!newsletterTitle) return;

  const text = newsletterTitle.textContent.trim();

  if (text === 'Ontvang als eerste onze nieuwe collecties') {
    newsletterTitle.innerHTML =
      'Ontvang als eerste onze <span class="footer-title-accent">nieuwe collecties</span>';
  }
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
